import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const userData = () => {
    const stringifiedUser = localStorage.getItem('user') || '""';
    return JSON.parse(stringifiedUser || {})
}

export const storeUser = (data) => {
    localStorage.setItem('user', JSON.stringify({
        username:data.user.username,
        jwt:data.jwt,
    }))
}

export const Protector = ({Component}) => {
    const history = useNavigate();

    const {jwt} = userData();

    useEffect(() => {

        if(!jwt){
            history('/login');
        }
    },[history, jwt])
}